/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { BaseTextElement } from './BaseTextElement';

export default BaseTextElement;
